module.exports = __webpack_public_path__ + "img/body-2.a457bad6.png";